import { call, put, select, takeLatest } from 'redux-saga/effects';
import { actions, types } from './reducers';
import { selectors as applicationSelectors } from '../../../../services/applications/reducers';
import api from '../../../../services/api/api';
import { Toast } from '../../../../components';
import staticText from '../../../../localization/Application/connect-config';

export function* fetchConnectConfig() {
  try {
    const applicationId = yield select(applicationSelectors.getSelectedApplication);

    const { data } = yield call(
      api.fetchConnectConfig,
      applicationId,
    );

    yield put(actions.fetchConnectConfigSuccess(data || {}));
  } catch (error) {
    yield put(actions.fetchConnectConfigFailure(error));
  }
}

export function* updateOrCreateConnectConfig(action) {
  try {
    const applicationId = yield select(applicationSelectors.getSelectedApplication);
    const { payload } = action;

    const { data } = yield call(
      api.updateOrCreateConnectConfig,
      applicationId,
      payload,
    );

    yield put(actions.updateConnectConfigSuccess(data));
    yield call(Toast, staticText.successMessage, 'success');
  } catch (error) {
    yield put(actions.updateConnectConfigFailure(error));
  }
}

export default function* rootSaga() {
  yield takeLatest(types.FETCH_CONNECT_CONFIG_REQUEST, fetchConnectConfig);
  yield takeLatest(types.UPDATE_CONNECT_CONFIG_REQUEST, updateOrCreateConnectConfig);
}
